document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('.js-our-artists');
  if (!section) return;

  const items = section.querySelectorAll('.js-our-artists-item');
  const carouselEl = section.querySelector('.js-featured-images-carousel');
  const imagesWrapper = section.querySelector('.js-featured-images');
  const toggleStatus = section.querySelector('.js-toggle-status');
  const mobileImages = section.querySelectorAll('.js-mobile-author-preview-image');

  if (!items.length || !carouselEl || !imagesWrapper || typeof Splide === 'undefined') return;

  let hideTimer = null;
  let isMobilePreviewActive = false;

  const splide = new Splide(carouselEl, {
    type: 'fade',
    rewind: true,
    arrows: false,
    pagination: false,
    drag: false,
    speed: 500,
  });

  splide.mount();

  const showCarousel = () => {
    clearTimeout(hideTimer);
    imagesWrapper.classList.add('is-visible');
  };

  const hideCarousel = () => {
    hideTimer = setTimeout(() => {
      imagesWrapper.classList.remove('is-visible');

      items.forEach((item) => {
        item.classList.remove('is-active');
      });
    }, 300);
  };

  const activateItem = (item) => {
    const index = Number(item.dataset.index) - 1;
    if (Number.isNaN(index)) return;

    items.forEach((el) => el.classList.remove('is-active'));

    item.classList.add('is-active');
    splide.go(index);

    showCarousel();
  };

  const toggleMobilePreview = () => {
    isMobilePreviewActive = !isMobilePreviewActive;

    section.classList.toggle('is-mobile-preview-active', isMobilePreviewActive);
    toggleStatus.classList.toggle('is-active', isMobilePreviewActive);

    mobileImages.forEach((image) => {
      image.classList.toggle('is-visible', isMobilePreviewActive);
    });
  };

  items.forEach((item) => {
    item.addEventListener('mouseenter', () => activateItem(item));
    item.addEventListener('focus', () => activateItem(item));

    item.addEventListener('mouseleave', hideCarousel);
    item.addEventListener('blur', hideCarousel);
  });

  if (toggleStatus && mobileImages.length) {
    toggleStatus.addEventListener('click', toggleMobilePreview);
  }
});